export default "https://cdn-static-staging.gokick.com/assets/fcb4ac80126f26ea915890c2472f26527471791c/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";